import React from 'react';
import {Typography, Tooltip, Link} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles(() => ({
  title: {
    marginBottom: 10,
  },
  infoIcon: {
    opacity: 0.5,
    left: 5,
    top: 4,
    position: 'relative',
  },
}));

const SectionHeader = ({title, tooltip, readMoreUrl}) => {
  const classes = useStyles();

  return (
    <Typography
      variant={'h6'}
      className={classes.title}
      align={title === 'Cumulative distribution' ? 'left' : undefined}
    >
      {title}
      <Tooltip
        arrow
        interactive={readMoreUrl ? true : false}
        title={
          <React.Fragment>
            {tooltip}
            {readMoreUrl && (
              <>
                <br />
                <Link href={readMoreUrl} target={'_blank'} color="primary">
                  Read more
                </Link>
              </>
            )}
          </React.Fragment>
        }
      >
        <InfoIcon className={classes.infoIcon} fontSize={'small'} />
      </Tooltip>
    </Typography>
  );
};

export default SectionHeader;
